import { Box, Stack, Typography } from "@mui/material";
import Image from "src/components/Image";

// ----------------------------------------------------------------------

export default function BlockContent() {
	return (
		<Stack
			alignItems='center'
			direction={{ xs: "column", md: "row" }}
			justifyContent='center'
			spacing={2}
			sx={{ width: 1, textAlign: { xs: "center", md: "left" }, maxHeight: 140 }}
		>
			<Image src={"/ilustrations/upload_amico.svg"} sx={{ maxHeight: 200, width: 200 }} />

			<Box sx={{ p: 3 }}>
				<Typography gutterBottom variant='h5'>
					Arrastra o selecciona el archivo
				</Typography>

				<Typography sx={{ color: "text.secondary", maxWidth: 330 }} variant='body2'>
					Suelta tus archivos o haz click&nbsp;
					<Typography
						component='span'
						sx={{ color: "primary.main", textDecoration: "underline" }}
						variant='body2'
					>
						aquí
					</Typography>
					&nbsp;para encontrarlos en tu dispositivo
				</Typography>
			</Box>
		</Stack>
	);
}
